export default "__VITE_ASSET__c2a267e0__"